import React from 'react';
import Table from './blueprint/components/Table/Table';
import { ConfigurationPoint } from 'models/interfaces/configurationExport/export';
interface ExportTableProps {
  className?: string;
  title: string;
  data: ConfigurationPoint[];
}
const ExportTable = ({ data = [], className = undefined, title = '' }: ExportTableProps) => {
  return (
    <React.Fragment>
      {title && <h3>{title}</h3>}
      <Table className={`category-points-table ${className ? className : ''}`}>
        <thead>
          <tr>
            <th>Categories</th>
            <th className="text-center">Points Allocated</th>
            <th className="text-center">Estimated Position</th>
          </tr>
        </thead>

        <tbody>
          {data &&
            data.map((row, i) => {
              return (
                <tr key={`tempKey1${i}`}>
                  <td className={''} key={`tempKey2${0}`}>
                    {row.label}
                  </td>
                  <td className={'text-center'} key={`tempKey2${1}`}>
                    {row.value}
                  </td>
                  <td className={'text-center'} key={`tempKey2${2}`}>
                    {row.position ? row.position : ''}
                  </td>
                </tr>
              );
            })}
        </tbody>
      </Table>
    </React.Fragment>
  );
};

// ExportTable.defaultProps = {
//   data: []
// };

export default ExportTable;
